<template>
    <div>
        <LazySudosuFrame />
        <LazyImmersionFrame />
        <ClientOnly v-if="loggedIn && !hideTermsAndConditionsPopup">
            <LazyTermsAndConditionsPopup />
        </ClientOnly>
        <ClientOnly v-if="loggedIn && !hideGDPRPopup">
            <LazyGDPRPopup />
        </ClientOnly>
        <slot v-if="isLoggedAsAdmin" name="admin-tools">
            <LazyFooterAdminTools />
        </slot>
        <slot />
        <LazyPlatformNotifications v-if="loggedIn" />

        <ClientOnly v-if="!loggedIn && !hideHostRedirectionDialog">
            <LazyHostRedirectionDialog />
        </ClientOnly>

        <EnvironnementMarker />
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {
        EnvironnementMarker,
        LazyFooterAdminTools,
        LazyGDPRPopup,
        LazyHostRedirectionDialog,
        LazyImmersionFrame,
        LazyPlatformNotifications,
        LazySudosuFrame,
        LazyTermsAndConditionsPopup,
    } from '#components';
    import {useAsyncData, useAuth, useHasEnoughPriviledge} from '#imports';

    const {data} = await useAsyncData('isAdmin', async () => {
        return {isAdmin: await useHasEnoughPriviledge(['ROLE_ADMIN'])};
    });

    const auth = useAuth();
    const {loggedIn} = storeToRefs(auth);
    const isLoggedAsAdmin = computed(() => loggedIn.value && data.value?.isAdmin);

    type BaseLayoutProps = {
        hideGDPRPopup?: boolean;
        hideHostRedirectionDialog?: boolean;
        hideTermsAndConditionsPopup?: boolean;
    };
    withDefaults(defineProps<BaseLayoutProps>(), {
        hideGDPRPopup: false,
        hideHostRedirectionDialog: false,
        hideTermsAndConditionsPopup: false,
    });
</script>
